import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
      <a href='https://sahilaherwar.github.io/Netflix-clone/'><ProjectsCard
          title="NetFlic Ui Clone"
          des=" A mimic of Netflix made using HTML, CSS, and JavaScript to recreate the visual and interactive elements of the Netflix streaming platform as a personal project."
          src={projectOne}
        /></a>
        <a href='https://note-app-nette.netlify.app/'><ProjectsCard
          title="Note App"
          des=" A comprehensive note-taking application for typing, editing, and responsive design using React, and styled-components for styling, with all data stored locally in the browser."
          src={projectTwo}
          href="www.google.com"
        /></a>
        <a href='https://afame-landing-page.netlify.app/'><ProjectsCard
          title="Vanilla Js Landing Page"
          des="A Minimalist landing page designed with HTML, CSS, JavaScript for interactivity and responsiveness."
          src={projectThree}
        /></a>
      </div>
      <div> 
          <p className='items-center text-center mt-[35px]'>Note: You can check my <a href='https://github.com/sahilaherwar?tab=repositories'className='text-decoration-line: underline'>GITHUB </a></p> 
      </div>
    </section>
  );
}

export default Projects